import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import GoogleButton from "@/components/GoogleButton";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({
    display_name: "",
    handle: "",
    email: "",
    password: "",
  });
  const [busy, setBusy] = useState(false);

  const update = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signup({
        ...form,
        handle: form.handle.replace(/^@/, "").toLowerCase(),
      });
      toast.success("Welcome to DAP.");
      nav("/app/mediakit");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Signup failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-24">
      <p className="font-mono text-xs uppercase tracking-widest text-[#CCFF00] mb-3">// let's dap it</p>
      <h1 className="font-display font-black text-5xl tracking-tighter mb-8">Claim your handle.</h1>
      <GoogleButton testId="signup-google-btn" label="Sign up with Google" />
      <div className="my-6 flex items-center gap-3 text-xs font-mono uppercase tracking-widest text-neutral-500">
        <span className="flex-1 h-px bg-white/10" /> or <span className="flex-1 h-px bg-white/10" />
      </div>
      <form onSubmit={submit} className="space-y-4" data-testid="signup-form">
        <Input
          placeholder="Display name (e.g. Sarah Chen)"
          value={form.display_name}
          onChange={update("display_name")}
          required
          className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
          data-testid="signup-name-input"
        />
        <div className="flex items-center gap-2">
          <span className="font-mono text-neutral-500 pl-2">dap.app/@</span>
          <Input
            placeholder="handle"
            value={form.handle}
            onChange={update("handle")}
            required
            className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
            data-testid="signup-handle-input"
          />
        </div>
        <Input
          type="email"
          placeholder="you@creator.com"
          value={form.email}
          onChange={update("email")}
          required
          className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
          data-testid="signup-email-input"
        />
        <Input
          type="password"
          placeholder="password (6+ chars)"
          value={form.password}
          onChange={update("password")}
          required
          className="h-12 bg-[#0e0e0e] border-white/10 focus-visible:ring-[#CCFF00] focus-visible:border-[#CCFF00]"
          data-testid="signup-password-input"
        />
        <Button
          type="submit"
          disabled={busy}
          className="w-full h-12 rounded-full bg-[#CCFF00] text-black hover:bg-[#b8e600] font-semibold"
          data-testid="signup-submit-btn"
        >
          {busy ? "Creating…" : "Create my DAP →"}
        </Button>
      </form>
      <p className="mt-6 text-sm text-neutral-400">
        Already on DAP?{" "}
        <Link to="/login" className="text-[#CCFF00] hover:underline" data-testid="signup-goto-login">
          Log in
        </Link>
      </p>
    </div>
  );
}
